module.exports = __webpack_public_path__ + "static/media/news-cmh-facility.ad765d5b.jpg";